<template>
    <div class="popup_wrpr product-settings-popup-wrap active">
        <div class="app_settings_popup" :class="{right_open: showRightPanel}">
            <div class="popup_left_side">

                <Loading v-show="loading"/>

                <a href="#" class="close_popup_btn" @click.prevent="closePopup">
                    <inline-svg :src="require('@/assets/img/popup_close.svg')"/>
                </a>

                <a href="#" class="right_toggle" :class="{active: showRightPanel}" @click.prevent="showRightPanel = !showRightPanel">
                    <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M6.96124 8.03874L6.37208 8.6279L2.74416 4.99999L6.37208 1.37207L6.96124 1.96124L3.92249 4.99999L6.96124 8.03874Z" fill="#E4E6F1"></path>
                    </svg>
                </a>

                <div class="popup_side_content scroll" v-if="newData" :class="{'not-valid': validationError}">
                    <h3 class="popup_title product-name layout-row" style="  border-bottom: 1px solid #e5e6f1;">
                      <span class="flex">
                        {{newData.name || ''}}
                      </span>

                      <div class="flex-none info_btn" @click="showRightPanel = !showRightPanel">
                        <span>Preview</span>
                        <inline-svg :src="require('@/assets/img/info_icon.svg')"/>
                      </div>
                    </h3>
                    <div class="brdr_content_wrpr">
                        <h3 class="brdr_content_title">Basic</h3>
                      <input-field required label="Product name" v-model="newData.name" @input="handleNameId($event)"
                                   info="This is the product name your customers will see, We recommend using the same product name in Clickfunnels.">
                      </input-field>
                      <div class="control-info" >
                        If you changed your product name, make sure to copy new product cart id from <strong>"Clickfunnels Tracking"</strong> panel below if needed.
                      </div>

                      <v-switch label="Is this an order bump?" v-model="newData.is_ob"
                                :value="newData.is_ob" @change="editCheckbox($event, 'is_ob')"></v-switch>
                    </div>
                    <div class="brdr_content_wrpr" >
                      <h3 class="brdr_content_title">Price</h3>

                      <v-switch label="Is a subscription?" v-model="newData.is_subscription"
                                :value="newData.is_subscription" @change="editCheckbox($event, 'is_subscription')"></v-switch>

                      <div class="mb-15" style="margin-top: 25px;" v-if="!newData.is_subscription">
                        <price-field :currency-code="currencyCode" label="Price" required
                                     v-model.number="newData.price" @change="editNumber($event, 'price')" />
                      </div>

                      <div class="form_group_col_4 billing-panel" style="margin-top: 25px;" v-if="newData.is_subscription">
                        <price-field class="billing-box" style="width: 130px;" :currency-code="currencyCode" label="Billing amount" required
                                     v-model.number="newData.billing_amount" @change="editNumber($event,'billing_amount')"></price-field>

                        <div class="form-group mb-15 with_top_block billing-box">
                          <span class="form_group_top_block">Recurring times</span>
                          <Select2 class="select2_arrow" @change="selectNumber($event, 'billing_recurring_times')"
                                   v-model="newData.billing_recurring_times" :options="recurringTimes.selectOptions" :settings="{dropdownAutoWidth: false, width: '100%', dropdownCssClass: 'no-search'}" />
                        </div>
                        <div class="form-group mb-15 with_top_block billing-box">
                          <span class="form_group_top_block" :class="{required: requiredField('billing_cycle', 'is_subscription')}">Billing cycle</span>
                          <Select2 class="select2_arrow" @change="selectNumber($event, 'billing_cycle')"
                                   v-model="newData.billing_cycle" :options="billingCycle.selectOptions"
                                   :settings="{dropdownAutoWidth: false, width: '100%', dropdownCssClass: 'no-search'}" />
                        </div>
                        <div class="form-group mb-15 with_top_block billing-box">
                          <span class="form_group_top_block" :class="{required: requiredField('cycle_type', 'is_subscription')}">Cycle type</span>
                          <Select2 class="select2_arrow" @change="selectNumber($event, 'cycle_type')"
                                   v-model="newData.cycle_type" :options="cycleType.selectOptions"
                                   :settings="{dropdownAutoWidth: false, width: '100%', dropdownCssClass: 'no-search'}" />
                        </div>
                      </div>

                      <div class="p-0 b-0 " v-if="newData.is_subscription">
                        <v-switch class="margin-b-20" label="Has a trial period?" v-model="newData.has_trial"
                                  :value="newData.has_trial" @change="editCheckbox($event, 'has_trial')"></v-switch>
                      </div>

                      <div class="form_group_col_3" v-if="newData.has_trial && newData.is_subscription" >

                        <price-field class="billing-box" style="min-width: 130px;" :currency-code="currencyCode"
                                     label="Billing amount" required v-model.number="newData.trial_billing_amount"
                                     @change="editNumber($event, 'trial_billing_amount')"></price-field>

                        <div class="form-group mb-15 with_top_block">
                          <span class="form_group_top_block" :class="{required: requiredField('trial_billing_cycle', 'has_trial')}">Billing cycle</span>
                          <Select2 class="select2_arrow" @change="selectNumber($event, 'trial_billing_cycle')"
                                   v-model="newData.trial_billing_cycle" :options="billingCycle.selectOptions" :settings="{dropdownAutoWidth: false, width: '100%', dropdownCssClass: 'no-search'}" />
                        </div>
                        <div class="form-group mb-15 with_top_block">
                          <span class="form_group_top_block" :class="{required: requiredField('trial_cycle_type', 'has_trial')}">Cycle type</span>
                          <Select2 class="select2_arrow" @change="selectNumber($event, 'trial_cycle_type')"
                                   v-model="newData.trial_cycle_type" :options="cycleType.selectOptions"
                                   :settings="{dropdownAutoWidth: false, width: '100%', dropdownCssClass: 'no-search'}" />
                        </div>
                      </div>

                      <div v-if="!newData.is_ob" class="margin-t-25">
                        <input-field interactive label="Displayed price (optional)"
                                     v-model="newData.display_price">
                          <template v-slot:info>
                            <p>
                              This will be the price "text" that will be shown to your customers on your order form (it will not affect the price they get charged).
                            </p>
                            <p class="info-message">This is only supported when using <b>Funnelish Pay</b>.</p>
                            <div class="info-message">
                              You can use dynamic texts such as:
                              <ul style="line-height: 20px">
                                <li><b>{PRICE} :</b> it will render the actual price of your product dynamically.</li>
                                <li><b>{CURRENCY} :</b> it will render the actual currency of your funnel dynamically.</li>
                                <li><b>{TRIAL-PRICE} :</b> it will render the actual billing amount of your product trial amount or "free" if it's free trial dynamically.</li>
                              </ul>
                            </div>
                          </template>
                        </input-field>
                      </div>
                    </div>

                    <div class="brdr_content_wrpr" v-if="!newData.is_ob">
                        <h3 class="brdr_content_title">Highlighting</h3>
                        <div class="brdr_box_w_checkbox p-0 b-0">
                            <label class="switch_checkbox_item">
                                <input type="checkbox" v-model="config.highlight">
                                <div class="switch_checkbox"><span></span></div>
                            </label>
                            <h3>Is highlighted?</h3>
                        </div>
                        <div class="control-info mb-15">
                            Activate the "Fancify" App under <strong>/Apps</strong> and <strong>Funnel > Apps,</strong> in order to use highlighting.
                        </div>
                        <div class="brdr_box_w_checkbox p-0 b-0" v-if="config.highlight">
                            <label class="switch_checkbox_item">
                                <input type="checkbox" v-model="config.default">
                                <div class="switch_checkbox"><span></span></div>
                            </label>
                            <h3>Select by default</h3>
                        </div>
                        <div class="brdr_box_w_checkbox p-0 b-0 mb-24" v-if="config.highlight">
                            <label class="switch_checkbox_item">
                                <input type="checkbox" v-model="config.super_highlight">
                                <div class="switch_checkbox"><span></span></div>
                            </label>
                            <h3>Bring Forward</h3>
                        </div>
                        <div class="form-group mb-15 with_top_block" v-if="config.highlight">
                          <input-field label="Top tag (Optional)" v-model="config.top_tag"></input-field>
                        </div>
                        <div class="form-group inline mb-24" v-if="config.highlight">
                            <div class="color-control">
                                <span class="label">Color:</span>
                                <v-swatches
                                    v-model="config.color"
                                    show-fallback
                                    shapes="circles"
                                    popover-x="right"
                                    fallback-ok-text="Set color"
                                    :swatches="swatches"
                                    :wrapper-style="{width: '145px', paddingLeft: '0'}"
                                    :swatch-style="{width: '25px', height: '25px', borderStyle: 'solid', borderColor: '#FFFFFF', borderWidth: '2px', marginRight: '5px', marginLeft: '5px'}"
                                ></v-swatches>
                            </div>
                            <div class="font-options">
                                <span class="label">Text Size:</span>
                                <label class="radio">
                                    <input type="radio" name="font" value="small" v-model="config.size">
                                    <span class="radiomark"></span>
                                    Small
                                </label>
                                <label class="radio">
                                    <input type="radio" name="font" value="big" v-model="config.size">
                                    <span class="radiomark"></span>
                                    Big
                                </label>
                            </div>
                        </div>
                        <div class="form-group mb-15 with_top_block" v-if="config.highlight">
                          <input-field label="Side tag (Optional)" v-model="config.tag"></input-field>
                        </div>
                    </div>
                    <div class="brdr_content_wrpr" v-if="newData.is_ob">
                        <h3 class="brdr_content_title">Clickfunnels Tracking</h3>
                        <div class="txt-wrap">
                            <p>
                                <strong>This is an order bump,</strong> in order to track your order bump sales you'll have to use the tracking ID provided within each product.
                            </p>
                            <p>
                                The <strong>"Cart Product ID + Orderbump"</strong> ID can be used to create a tracking product within Clickfunnels for the order bump when combined with each product.
                            </p>
                        </div>
                    </div>
                    <div class="brdr_content_wrpr" v-else>
                        <h3 class="brdr_content_title">Clickfunnels Tracking</h3>
                        <div class="txt-wrap">
                            <p>
                                In order to have your sales tracked in Clickfunnels,
                                you'll have to copy the Product Cart ID below and add it to your PayPal product in Clickfunnels under <strong>"Your Funnel" > Settings > 3rd Party Membership Access.</strong>
                            </p>
                        </div>
                        <div class="form-group with-copy-icon mb-15 with_top_block">
                            <span class="form_group_top_block">Cart product ID</span>
                            <input disabled type="text" class="control-input" v-model="newData.friendly_id">
                            <div class="copy-icon" @click="copyClipboard($event, newData.friendly_id)">
                                <inline-svg :src="require('@/assets/img/copy_icon_sm.svg')"/>
                            </div>
                        </div>
                        <div class="control-info mb-24">
                            Use this ID to track sales of the current product when bought alone.
                        </div>
                        <div class="form-group with-copy-icon mb-15 with_top_block">
                            <span class="form_group_top_block">Cart Product ID + Orderbump</span>
                            <input disabled type="text" class="control-input" v-model="newData.order_bump_id">
                            <div class="copy-icon" @click="copyClipboard($event, newData.order_bump_id)">
                                <inline-svg :src="require('@/assets/img/copy_icon_sm.svg')"/>
                            </div>
                        </div>
                        <div class="control-info">
                            Use this ID to track sales of the current product when bought with the order bump.
                        </div>
                    </div>
                    <div class="brdr_content_wrpr" v-if="newData.is_ob">
                        <h3 class="brdr_content_title">Variants</h3>
                        <div class="txt-wrap">
                            <p>
                                Order bumps do not support having variants, If you believe this is something we should work on then do let us know at <a href="mailto:support@funnelish.com" target="_blank">support@funnelish.com</a>.
                            </p>
                        </div>
                    </div>

                  <!-- Variants -->
                    <div class="brdr_content_wrpr" v-else>
                        <h3 class="brdr_content_title">Variants</h3>
                        <div class="txt-wrap">
                            <p>
                                Add variants if this product has multiple options, such as size or color.
                            </p>
                        </div>
                        <div class="variants-wrap">
                            <div class="variant-box" v-for="(item, index) in newVariants" :key="index">
                                <div class="left">
                                    <div class="label with-icon">
	                                    Variant <info-icon>eg. color, size...</info-icon>
                                    </div>
                                    <div class="form-group">
                                      <input-field v-model="item.name"></input-field>
                                    </div>
                                    <div class="delete-icon" @click="deleteVariant(index)"><inline-svg :src="require('@/assets/img/delete_icon.svg')"/></div>
                                </div>
                                <div class="right">
                                    <div class="label-top-group">
                                        <div class="label with-icon">
                                            Options <info-icon>eg. Blue, Green, M, L, XS...etc</info-icon>
                                        </div>
                                    </div>
                                    <p v-if="!item.options.length" class="msg">No options yet, add an option to get started.</p>
                                    <div v-else class="option-items-wrap">
                                        <div class="option-item" v-for="(option, optindex) in item.options" :key="optindex">
                                          <input-field v-model="option.name"></input-field>
                                            <div class="delete-icon" @click="deleteOption(index, optindex)">
                                                <inline-svg :src="require('@/assets/img/delete_icon.svg')"/>
                                            </div>
                                        </div>
                                    </div>
	                                <div class="layout-row">
		                                <v-button border label="Add new option" :locked="!is('editor')"
		                                          @click="addNewOption(index)" />
	                                </div>
                                </div>
                            </div>
	                        <div class="layout-row">
		                        <v-button border label="Add new variant" :locked="!is('editor')"
		                                  @click="addNewVariant" />
	                        </div>
                        </div>
                    </div>
                    <!-- Automations -->
                    <div class="brdr_content_wrpr">
                        <h3 class="brdr_content_title">Automations</h3>
                        <div class="txt-wrap mb-15">
                            <p>
                                Trigger any action with our 3rd party integrations when the product is purchased, refunded, subscribed to, or canceled.
                            </p>
                        </div>
                        <div class="automation-items entries-table" v-if="newAutomations.length">
                            <automation-entry
                                v-for="item in newAutomations" :key="item.id"
                                :item="item"
                                :title="automationTitle(item.trigger_id)"
                                @click="editAutomationItem(item)"
                                @delete="itemEntryDeleteClick"
                            />

                            <DeleteAutomationPopup
                                :automation="currentAutomation"
                                v-if="isdeleteAutomationOpen"
                                @done="deleteAutomationItem($event.id)"
                                @close="isdeleteAutomationOpen=false,currentAutomation=null"
                            />
                        </div>

	                    <div class="layout-row">
		                    <v-button border :locked="!is('automations')"
		                              @click="showAutomationPopup" label="Create new automation"></v-button>
	                    </div>
                    </div>
                </div>
                <div class="bottom_btns_wrpr">
                    <div class="left">
	                    <div class="layout-row">
		                    <a @click.prevent="closePopup" class="btn brdr_btn">Cancel</a>
		                    <v-button @click.prevent="saveData" :disabled="validation.length>0"
		                              :locked="!is('editor')"
		                              :loading="saving" label="Save changes"></v-button>
	                    </div>
                    </div>
                    <v-button label="Delete Product" v-if="currentProduct && currentProduct.id" border red
                              :locked="!is('editor')"
                         @click="deleteProduct(currentProduct.id)" />
                </div>
            </div>
            <div class="popup_right_side">
                <product-preview v-show="showRightPanel" :variants="newVariants" :step="funnelStep"
                                 :products="products" :product="newData"></product-preview>
            </div>
        </div>
        <input type="hidden" id="cfw_url_hidden" :value="`${clipboardValue}`">

	    <portal to="popup" v-if="openAutomation">
			    <AutomationPopup :is-edit="!currentAutomation || !!currentAutomation.id" :product="currentProduct"
			                     :automation="currentAutomation"
			                     :step-id="$route.params.step" :funnel-id="$route.params.id" :is-plus="false"
			                     @close="openAutomation=false" @done="automationSaved"  />
		    </portal>
    </div>
</template>

<script>
import VSwatches from 'vue-swatches'
import 'vue-swatches/dist/vue-swatches.css'
import API from "@/api"
import Loading from "@/components/Loading.vue"
import {mapGetters} from "vuex"
import ProductPreview from "@/views/funnels/steps/product_preview/product_preview";

import DeleteAutomationPopup from "@/views/funnels/steps/products/delete_automation_popup";
import automationItemEntry from "@/views/funnels/steps/products/automationItemEntry.vue";

import InputField from "@/components/base/input-field";
import VSwitch from "@/components/base/v-switch";
import PriceField from "@/components/base/price-field";
import VButton from "@/components/base/v-button";
import AutomationPopup from "@/components/popups/automation/AutomationPopup.vue";
import InfoIcon from "@/components/base/info-icon";
import {is} from "@/helpers/roles";
import AutomationEntry from "@/views/funnels/funnel-plus/steps/products/automation-entry";

export default {
    name: "ProductSidePanel",
    props: {
      funnelStep: {
        default: () => {},
      },
        products: {
          require: true,
          type: Array,
          default: () => [],
        },
        delete: {
            require: true,
            type: Function
        }
    },
    components: {
	    AutomationEntry,
	    InfoIcon,
        VButton,
        PriceField,
        VSwitch,
        InputField,
        DeleteAutomationPopup,
        automationItemEntry,
        ProductPreview,
	    AutomationPopup,
        VSwatches,
        Loading
    },
    mixins: [API],
    data() {
        return {
          saving: false,
          isdeleteAutomationOpen: false,
          currentAutomation: null,
	        openAutomation:false,
            validationError: false,
            newData: {},
            loading: true,
            config: {},
            color: "#68C2E9",
            swatches: ['#FB595B', '#68C2E9', '#15D7AE', '#FDCC5E', '#4368E0', '#252A32', '#636A7B', '#C5C7D2', '#2E408C', '#97AACD', '#449CF4', '#6689FC'],
            newVariants: [],
            newAutomations: [],
            showRightPanel: false,
            settingsToggle: true,
            recurringTimes: {
                selectValue: 4,
                selectOptions: [{id:0, text:'Infinite'}, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24,25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52],
            },
            billingCycle: {
                selectValue: 4,
                selectOptions: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24,25, 26, 27, 28, 29, 30],
            },
            cycleType: {
                selectValue: 'day(s)',
                selectOptions: [
                    {id: 1, text: "day(s)"},
                    {id: 2, text: "week(s)"},
                    {id: 3, text: "month(s)"},
                    {id: 4, text: "year(s)"}
                ],
            },
            validation: [],
            currentProduct: {},
            clipboardValue: ''
        }
    },
    computed: {
        ...mapGetters(["getAutomationData", "getAutomationPopup", "ifError", 'getFunnelStore']),
      currencyCode: function () {
          return this.getFunnelStore.currency_code;
      },
    },
    watch: {
        config: {
          handler(val){
            try {
              this.newData.config = JSON.stringify(val)
            }catch (e) {}
          },
          deep: true
        },
        getAutomationData(val) {
            console.log('getAutomationData', val);
            this.$nextTick(() => this.init());
        },
    },
    methods: {
    	is(role){
    		return is(role)
	    },
        //UI
        requiredField(optionOne, optionTwo = false) {
            var conditionOne = false, conditionTwo = false;
            if(optionTwo) {
                conditionTwo = this.newData[optionTwo]
            }
            conditionOne = this.newData[optionOne] ? this.newData[optionOne] > 0 : false;

            var result = (!conditionOne);
            return result
        },
        handleNameId(value) {
            let id = value.replace(/ /gi, "_").toUpperCase();
            let obId = id + '-OB';
            this.newData['friendly_id'] = id;
            this.newData['order_bump_id'] = obId;
        },
        copyClipboard(event, text) {
            this.clipboardValue = text;

            setTimeout(() => {
                let elemToCopy = document.querySelector('#cfw_url_hidden');
                elemToCopy.setAttribute('type', 'text');
                elemToCopy.select();

                try {
                    var successful = document.execCommand('copy');
                } catch (err) {
                    console.log('Oops, unable to copy');
                }

                elemToCopy.setAttribute('type', 'hidden')
                window.getSelection().removeAllRanges()
            }, 100);
        },
        selectNumber(event, field) {
            isNaN(event) ? event = 0 : '';
            this.newData[field] = parseFloat(event);
        },
        editNumber(event, field) {
            isNaN(value) ? value = 0 : '';
            this.newData[field] = parseFloat(value);
        },
        editCheckbox(checked, field) {
            this.newData[field] = checked
        },
        editInfo(event, field) {
            this.newData[field] = event.target.value
        },
	    automationSaved() {
		    this.openAutomation = false;
		    this.currentAutomation = false;
		    this.updateAutomations();
	    },
        editAutomationItem(item) {
            this.updateInfo();
						this.currentAutomation = item;
						this.openAutomation = true;
        },
        showAutomationPopup() {
	        this.currentAutomation = {};
	        this.updateInfo();
	        this.openAutomation = true;
        },
        closePopup() {
            var {id, step} = this.$route.params;
            this.$router.push({path: `/funnel/${id}/steps/${step}`});
        },
        addNewVariant() {
            this.newVariants.push({
                name: '',
                options: [{ name: '', soldout: false }]
            })
        },
        deleteVariant(index) {
            this.newVariants.splice(index, 1);
        },
        addNewOption(index) {
            this.newVariants[index].options.push({
                name: '',
                soldout: false
            })
        },
        deleteOption(index, optindex) {
            this.newVariants[index].options.splice(optindex, 1)
        },
        deleteProduct(id) {
            this.$store.commit("showProductDeletePopup");
        },
        automationTitle(id) {
            var title = 'On Purchase';
            var trigger = parseInt(id);
            switch(trigger) {
                case 1:
                    title = 'On Purchase'
                    break;
                case 2:
                    title = 'On Refund'
                    break
                case 3:
                    title = 'New Subscription'
                    break
                case 4:
                    title = 'Subscription Cancelled'
                    break
            }
            return title
        },
        itemEntryDeleteClick(item){
            this.currentAutomation = item;
            this.isdeleteAutomationOpen = true;
        },
        //API
        async updateInfo() {
            if(this.currentProduct.id) {
                //EXISTING PRODUCT
                var data = {
                    id: this.currentProduct.id,
                    user_id: parseInt(this.$store.state.user),
                    variants: JSON.stringify({variants: this.newVariants})
                }
                var varinatsResult = await this.api.steps.patchVariants(this.currentProduct.id, data);
            } else {
                //NEW PRODUCT
                var result = await this.api.steps.createProduct(this.newData);
                if(result.error) console.log('PRODUCT CREATE ERROR');
                else {
                    var newId = await result.id;
                    var data = {
                        id: newId,
                        user_id: parseInt(this.$store.state.user),
                        variants: JSON.stringify({variants: this.newVariants})
                    }
                    var varinatsResult = await this.api.steps.patchVariants(newId, data);
                    this.$emit('update');
                    var { id, step } = this.$route.params;
                    this.$router.push({path: `/funnel/${id}/steps/${step}/product/${newId}`})
                }
            }
        },
        async deleteAutomationItem(id) {
          this.currentAutomation = null;
          this.isdeleteAutomationOpen = false;
          this.newAutomations = this.newAutomations.filter((item) => item.id !== id)
        },
        async saveData() {
            var errors = document.querySelectorAll('.app_settings_popup .required');
            if(errors.length) {
                this.validationError = true;
                this.$notify({
                  type:"warn",
                  group: "main",
                  title: "Looks like some required fields are empty",
                });
                setTimeout(()=> {
                    this.validationError = false;
                }, 5000)
            } else {
              try {
                this.validationError = false;
                this.saving = true;
                this.newData.config = JSON.stringify(this.config);

                if (this.currentProduct.id) {
                  var result = await this.api.steps.patchProduct(this.currentProduct.id, this.newData);
                  this.$store.dispatch('EDIT_PRODUCT', result);

                } else {
                  var result = await this.api.steps.createProduct(this.newData);
                  this.$store.dispatch('ADD_PRODUCT', result);
                }

                if (!this.ifError) {
                  var data = {
                    product_id: result.id,
                    user_id: parseInt(this.$store.state.user),
                    variants: JSON.stringify({variants: this.newVariants})
                  }

                  var varinatsResult = await this.patchVariants(result.id, data);

                  this.closePopup();
                }
              } catch (e) {
                this.$error(e)
              } finally {
                this.saving = false;
              }
            }
        },
        async init() {
            this.$store.commit("showProductSettingsPopup");
            var { id, step, productId } = this.$route.params;
            if(productId !== 'create-new') {
                //EXISTING PRODUCT
                var productRes =  await this.api.steps.getVariants(productId);
                this.currentProduct = productRes;

                try {
	                this.newVariants = JSON.parse(productRes.variants.variants).variants
                } catch (e) {
	                console.error(e)
	                this.newVariants = [];
                }

	            this.newAutomations = await this.api.steps.getAutomations(this.currentProduct.id);
            } else {
                //NEW PRODUCT
                var prodRes = await this.api.steps.getProducts(step);
                this.products = prodRes;
                //EMPTY PRODUCT MODEL
                this.currentProduct = {
	                "name": 'BRAND NEW PRODUCT',
	                "price": null,
	                "created_at":null,
	                "updated_at":null,
	                "step_id": parseInt(step),
	                "funnel_id": parseInt(id),
	                "order_index": this.products.length + 1,
	                "friendly_id": 'BRAND_NEW_PRODUCT',
	                "order_bump_id": 'BRAND_NEW_PRODUCT-OB',
	                "is_subscription": false,
	                "billing_amount": null,
	                "billing_cycle": null,
	                "cycle_type": null,
	                "has_trial": false,
	                "trial_billing_amount": null,
	                "trial_billing_cycle": null,
	                "trial_cycle_type": null,
	                "billing_recurring_times": null,
	                "config": "{\"highlight\":false,\"default\":false,\"super_highlight\":false,\"top_tag\":\"\",\"tag\":\"\",\"color\":\"silver\",\"size\":\"small\"}",
	                "min_order": null,
	                "max_order": null,
	                "checkout_type": null,
	                "is_ob": false
                }
                this.newVariants = []
            }
            var safeString = JSON.stringify(this.currentProduct);
            this.newData = JSON.parse(safeString);

            if(this.newData.config && this.newData.config.length) {
                this.config = JSON.parse(this.newData.config) || {};
            } else {
                this.config = {};
            }

            this.$nextTick(()=> this.loading = false );
        },
        async updateAutomations() {
	        this.newAutomations = await this.api.steps.getAutomations(this.currentProduct.id);
        },
    },
    mounted() {
        this.init();
    }
}
</script>

<style lang="scss" scoped>
.automation-items {
	display: flex;
	flex-direction: column;
	gap: 10px;
	margin-bottom: 15px;
}
.variants-wrap {
  .input-field {
    height: 32px;
    background: white;
  }
}
.product-name {
  max-width: 625px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  display: flex;
  > span {
    display: block;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
}
.billing-panel {
  display: flex;
  flex-direction: row;
  flex-grow: 1;
  flex-wrap: nowrap;

  .billing-box {
    margin-right: 10px;
    flex-grow: 1;
    flex-shrink: 0;
    &:last-child {
      margin-right: 0;
    }
  }
}

  .form-group.with_top_block .copy-icon {
      transition: 0.15s;
  }
  .form-group.with_top_block .copy-icon:hover {
      background: #D5E5FF;
  }
</style>
